import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { TopBar } from './components/TopBar';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { Home } from './pages/Home';
import { AboutPage } from './pages/AboutPage';
import { ProjectsPage } from './pages/ProjectsPage';
import { BidsPage } from './pages/BidsPage';
import { ProcurementPage } from './pages/ProcurementPage';
import { SupplierRegistrationPage } from './pages/SupplierRegistrationPage';
import { ContactPage } from './pages/ContactPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen flex flex-col font-sans text-gray-800 bg-white" data-id="element-2">
        <TopBar data-id="element-3" />
        <Header data-id="element-4" />
        <main className="flex-grow" data-id="element-5">
          <Routes data-id="element-6">
            <Route path="/" element={<Home data-id="element-8" />} data-id="element-7" />
            <Route path="/about" element={<AboutPage data-id="element-10" />} data-id="element-9" />
            <Route path="/projects" element={<ProjectsPage data-id="element-12" />} data-id="element-11" />
            <Route path="/bids" element={<BidsPage data-id="element-14" />} data-id="element-13" />
            <Route path="/procurement" element={<ProcurementPage data-id="element-16" />} data-id="element-15" />
            <Route path="/procurement/supplier-registration" element={<SupplierRegistrationPage data-id="element-18" />} data-id="element-17" />
            <Route path="/contact" element={<ContactPage data-id="element-20" />} data-id="element-19" />
          </Routes>
        </main>
        <Footer data-id="element-21" />
      </div>
    </BrowserRouter>;
}